import script from "./templateDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./templateDownload.vue?vue&type=script&setup=true&lang=js"

import "./templateDownload.vue?vue&type=style&index=0&id=604218d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-604218d8"]])

export default __exports__